import * as cohort from '../../actionTypes/Cohort/Cohort'
import Constants from '../../Constants'
import Api from '../../Api'

const api = new Api();

function getCohortsSuccess (cohorts) {
  return {
    type: cohort.GET_COHORT,
    cohorts,
  }
}

function getCohortsSelectionsConfig (cohortsSelections) {
  return {
    type: cohort.GET_COHORT_SELECTION_LIMIT,
    cohortsSelections,
  }
}

function getCohortsOrganizationsSuccess (cohortsOrganizations) {
  return {
    type: cohort.GET_COHORT_ORGANIZATIONS,
    cohortsOrganizations,
  }
}

export const getCohorts = (id) => {
  return async (dispatch) => {
    try {
      const url = Constants.apiUrls.cohorts + '?casId=' + id;
      const resp = await api.getData(url)
      dispatch(getCohortsSuccess(resp));
    } catch (err) {
      console.error(err);
    }
  }
}

export const getCohortsSelections = (id) => {
  return async (dispatch) => {
    try {
      const url = Constants.apiUrls.cohortConfig + '?casId=' + id;
      const resp = await api.getData(url);
      dispatch(getCohortsSelectionsConfig(resp));
    } catch (err) {
      console.error(err);
    }
  }
}

export const getCohortsOrganizations = (id) => {
  return async (dispatch) => {
    try {
      const url = Constants.apiUrls.cohortsOrgs + '?casId=' + id;
      dispatch({
        type: cohort.GET_COHORT_ORGANIZATIONS_LOADING,
      });
      const resp = await api.getData(url);
      dispatch(getCohortsOrganizationsSuccess(resp));
    } catch (err) {
      console.error(err);
    }
  }
}
